import React from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import {
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
} from "@mui/material";
import { useSignOut } from "../../generated/hook";

const SignOutPage: React.FC = () => {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(true);
  const [, setLoading] = React.useState(false);

  const { mutate: logout, isPending } = useSignOut({
    mutation: {
      onSuccess: () => {
        // Clear JWT token from cookies
        Cookies.remove("token");
        navigate("/");
      },
    },
  });

  const handleConfirm = () => {
    setLoading(true);
    logout();
  };

  const handleClose = () => {
    setOpen(false);
    navigate("/");
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Confirm Sign Out</DialogTitle>
      <DialogContent>
        <Typography>Are you sure you want to sign out?</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={isPending}>
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="primary"
          disabled={isPending}
          startIcon={isPending ? <CircularProgress size={20} /> : undefined}
        >
          Sign Out
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SignOutPage;
